export default __webpack_public_path__ + "static/media/dashboard.31c6a448.svg";